// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__oeWTQ","top":"Footer_top__3ag2b","subscribe":"Footer_subscribe__SXNQd","bottom":"Footer_bottom__3cQ0m","contact":"Footer_contact__2Nbnd"};